<template>
  <section :id="module.id" class="action-bar" :style="actionBarElStyles">
    <div class="content">
      <div class="text-area">
        <div v-if="jobData?.title" class="title">
          {{ jobData.title }}
        </div>
      </div>

      <div class="button-area">
        <template
          v-if="actionBarConfig.config.general.style.value === 'navigation'"
        >
          <NavigationCta
            v-if="module.config.applyButton"
            :cta-button="module.config.applyButton"
            :href="jobData.application_url"
            :cta-button-el-styles="ctaButtonElStyles"
            @emitted-click="$emit('emittedClick', $event)"
          />
          <NavigationCta
            v-if="jobData.pitch_you_url && pitchYouButton"
            :cta-button="pitchYouButton"
            :href="jobData.pitch_you_url"
            :cta-button-el-styles="ctaButtonElStylesPitchYou"
            @emitted-click="$emit('emittedClick', $event)"
          />
        </template>
        <template v-else>
          <GlobalUIApplyButton
            v-if="module.config.applyButton"
            :button="module.config.applyButton"
            :application-url="jobData.application_url"
            @emitted-click="$emit('emittedClick')"
          />
          <GlobalUIApplyButton
            v-if="jobData.pitch_you_url && pitchYouButton"
            :button="pitchYouButton"
            :application-url="jobData.pitch_you_url"
            @emitted-click="$emit('emittedClick')"
          />
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import heroModule from "../Hero/heroDefaultModuleProp";
import navigationGlobalProps from "../Navigation/navigationDefaultGlobalProps";
import exampleActionBarConfigProp from "./exampleActionBarConfigProp";
import GlobalUIApplyButton from "../GlobalUI/GlobalUIApplyButton/GlobalUIApplyButton.vue";
import NavigationCta from "../Navigation/UI/NavigationCta.vue";
import { moduleMixins } from "../../utils/mixins/moduleMixins.js";
import { pitchYouButtonMixin } from "../../utils/mixins/pitchYouButtonMixin.js";

export default {
  name: "ActionBar",
  components: {
    GlobalUIApplyButton,
    NavigationCta,
  },
  mixins: [moduleMixins, pitchYouButtonMixin],
  props: {
    module: {
      type: Object,
      required: true,
      default() {
        return heroModule;
      },
    },
    actionBarConfig: {
      type: Object,
      default() {
        return exampleActionBarConfigProp;
      },
    },
    jobData: {
      type: Object,
      default: () => ({}),
    },
    navigationGlobal: {
      type: Object,
      default() {
        return navigationGlobalProps;
      },
    },
  },
  emits: ["emittedClick"],
  computed: {
    actionBarElStyles() {
      const { backgroundColor } = this.module.config.general;
      const headerTextColor = this.module.config.header.textColor;
      const headerCapitalLetters = this.module.config.header.isTextInCaps;

      return {
        "--action-bar-background-color": backgroundColor.value,
        "--action-bar-header-text-color": headerTextColor.value,
        "--action-bar-header-capital-letters": headerCapitalLetters
          ? "uppercase"
          : "initial",
      };
    },
    // pitchYouButton is now provided by the pitchYouButtonMixin
  },
};
</script>

<style lang="scss" scoped>
.action-bar {
  container-type: inline-size;
  contain: layout;

  width: 100%;
  align-content: center;
  align-items: center;
  justify-content: space-around;

  position: fixed;

  width: 100%;
  height: 75px;
  padding: 8px 32px;
  bottom: 0;
  z-index: 80;

  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;

  overflow: hidden;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.05);

  background-color: var(--action-bar-background-color);
}

.content {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  max-width: 1280px;

  @include mobile {
    justify-content: center;
  }
}

.text-area {
  flex-shrink: 0;
  display: block;

  @include mobile {
    display: none;
  }
}

.button-area {
  display: flex;
  align-items: stretch;
  gap: 10px;

  :deep(.apply-button) {
    height: 29px;
    padding: 8px 29px;

    @include min-laptop {
      width: auto;
    }

    @include tablet {
      max-width: 250px;
    }

    @include mobile {
      height: auto;
    }
  }

  :deep(.cta) {
    display: flex;
  }
}

.title {
  @include font-family("heading");
  @include scale-fonts("action-bar-title");

  color: var(--action-bar-header-text-color);
  text-transform: var(--action-bar-header-capital-letters);
}
</style>
